import React, {useState, useEffect} from "react";
import BForm from "../components/forms/BForm";
import { regionsService } from "../service/regionsService";
import validatePlzs from "../utilis/plzsValidation";

export default function EditMaklersForm({ onSubmit, btnText, preloadedData , isNew, responseErrors}) {
  const [provinces, setProvinces] = useState();

  useEffect(() => {
    regionsService.getAllRegions()
    .then((res) => {
      let data = res.data.map((el) => ({
        value: el.id,
        label: el.name,
      }))
      setProvinces(data);
    })
  }, [])
  
  const fields = [
    {
      fieldName: "firstName",
      placeholder: "Vorname",
      validation: {
        required: true,
      },
    },
    {
      fieldName: "lastName",
      placeholder: "Nachname",
      validation: {
        required: true,
      },
    },
    {
      fieldName: "companyName",
      placeholder: "Firmenname",
      validation: {
        required: true,
      },
    },
    {
      fieldName: "logo",
      placeholder: "Logo",
      type: "file"
    },
    {
      fieldName: "email",
      placeholder: "Email",
      validation: {
        required: true,
        pattern: {
          value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
          message: "Email isn't valid!",
        },
      },
    },
    {
      fieldName: "phoneNumber",
      placeholder: "Telefonnummer",
      validation: {
        required: true,
        pattern: {
          value: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/,
          message: "Phone number isn't valid! Try (123 456 789)",
        },
      },
      type: "number",
    },
    {
      fieldName: "regions",
      placeholder: "Bezirk",
      validation: {
        required: true,
      },
      type: "multiselect",
      options: provinces,
    },
    {
      fieldName: "zipCodes",
      placeholder: "Postleitzahlen durch Kommas trennen",
      validation: {
        required: true,
        validate: {
          checkPlzs: v => validatePlzs(v) || "This isn't valid zip code!"
        },
      },
      type: "textarray",
    },
    {
      fieldName: "responsibilityArea",
      placeholder: "Verantwortungsbereich",
      validation: {
        required: true,
      },
    },
    /*{
      fieldName: "points",
      placeholder: "Punkte",
      validation: {
        required: true,
        max: {
          value: 1000,
          message: "Field can't be greater than 1000",
        },
      },
      type: "number",
    },*/
    {
      fieldName: "price",
      placeholder: "Preis",
      validation: {
        required: true,
      },
    },
    {
      fieldName: "note",
      placeholder: "Notizen",
    }
  ];

  return (
    <BForm
      preloadedData={preloadedData}
      btnText={btnText}
      submit={onSubmit}
      fields={fields}
      responseErrors={responseErrors}
    />
  );
}
